import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

export default function setBrandsCarousel() {
  const brandsContainer = document.querySelector("[data-swiper-brands]");

  if (brandsContainer) {
    const brandsSwiper = new Swiper(brandsContainer.querySelector('.swiper'), {
      modules: [Autoplay, Navigation, Pagination],
      slidesPerView: 6,
      
      // ALTERAÇÃO 1: Mudar groups para 1 para rolagem mais suave no marquee
      slidesPerGroup: 1, 
      
      spaceBetween: 16,
      watchOverflow: true,
      preloadImages: false,
      
      // ALTERAÇÃO 2: Aumentar a velocidade para tornar a rolagem lenta (8000ms = 8 segundos)
      speed: 8000, 
      
      // ALTERAÇÃO 3: Ativar o loop infinito
      loop: true, 
      
      autoplay: {
        // ALTERAÇÃO 4: Definir delay como 0 para rolagem contínua
        delay: 0, 
        
        // ALTERAÇÃO 5: Não parar o autoplay quando o usuário interage
        disableOnInteraction: false, 
        
        // ALTERAÇÃO 6: Manter a pausa ao passar o mouse
        pauseOnMouseEnter: true, 
        
        // ALTERAÇÃO 7: Adicionar a direção reversa para o efeito marquee
        reverseDirection: false, // Defina como 'true' se quiser que ele role da direita para a esquerda
      },
      
      navigation: {
        nextEl: brandsContainer.querySelector('.swiper-button-next'),
        prevEl: brandsContainer.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: brandsContainer.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        767: {
          slidesPerView: 4,
        },
        992: {
          slidesPerView: 8,
        },
        1368: {
          slidesPerView: 5, 
        },
      }
    });

    // ALTERAÇÃO 8: REMOVER a lógica de inicialização tardia
    // Remova as seguintes linhas para que o autoplay comece imediatamente:
    // brandsSwiper.autoplay.stop();
    // const initAutoplay = () => { brandsSwiper.autoplay.start(); }
    // const eventType = (window.innerWidth <= 1024) ? 'scroll' : 'mousemove'
    // window.addEventListener(eventType, initAutoplay, { once: true });
    
    // O autoplay começará automaticamente com as configurações acima.
  }
}  